module.exports = __webpack_public_path__ + "static/visie-1-fbdeaca800bf1ad21ce9cb0626ef2f97.jpg";